import { IBaseModel } from './base.model';
import { IClassOfBusiness } from './class-of.business';
import { IPeril } from './peril.model';
import { IInsurer } from './insurer.model';
import { IQueryParams } from './queryparams';
import {
  IDiscount,
  IPremiumRequest,
  IProductExclusion,
  IProductWarranty,
  IProductExtension,
} from './addon.model';
import { GeneralProductType, IGeneralProduct } from './general-product.models';
import { IMotorProduct } from './motor-product.model';
import { ITravelProduct } from './travel-product.model';
import { ILifeProduct } from './life.model';
import { PaymentMethod } from './payment.model';

export type DistributionChannel =
  | 'Direct'
  | 'Intermediary'
  | 'SelfServiceUssd'
  | 'SelfServiceWeb'
  | 'SelfServiceMobile'
  | 'IntermediaryMobile'
  | 'Marketplace';
export const DistributionChannels = [
  'Direct',
  'Intermediary',
  'SelfServiceUssd',
  'SelfServiceWeb',
  'SelfServiceMobile',
  'SelfService',
  'IntermediaryMobile',
  // Gari's "buy from an insurer" route; broker listings on Gari are set per broker product instead
  'Marketplace',
];

export type ProductStatus = 'Active' | 'Inactive' | 'Deleted';

export interface IcProductDocument extends IBaseModel {
  name: string;
  url: string;
}

export interface IProductCategory {
  id: number;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string;
  isActive: boolean;
  classOfBusinessId: number;
}

export interface IProductCategoryRequest {
  name: string;
  description: string;
  isActive: boolean;
  classOfBusinessId: number;
}

export interface ICodeRule {
  clientType: 'Individual' | 'Corporate' | null;
  riskCategoryId: number | null;
  code: string;
}

export interface IProduct extends IBaseModel {
  name: string;
  code: string;
  description: string;
  commissionRate: number;
  insurer: IInsurer;
  classOfBusiness: IClassOfBusiness;
  perils: IPeril[];
  distributionChannels: DistributionChannel[];
  status: ProductStatus;
  documents: IcProductDocument[];
  paymentMethods: PaymentMethod[];
  type: string;
  category?: IProductCategory | null;
  productCategoryId?: number | null;
  productCategoryName?: string | null;
  codeRules?: ICodeRule[] | null;
  defaultExtensions?: IProductExtension[];
  defaultExclusions?: IProductExclusion[];
  defaultWarranties?: IProductWarranty[];
}

export interface IProductQueryParams extends IQueryParams {
  InsurerId?: number | null;
  partnerId?: number | null;
  intermediaryId?: number | null;
  classOfBusinessId?: number | null;
  brokerId?: number | null;
  productId?: number;
  productType?: string;
  query?: string;
  productCategoryId?: number | null;
  distributionChannels?: DistributionChannel[];
  statuses: ProductStatus[];
  insurers?: number[] | null;
  classOfBusinessIds?: number[] | null;
}

export interface IGeneralProductQueryParams extends IProductQueryParams {
  type?: GeneralProductType;
}

export interface IProductsQuery extends IQueryParams {
  query?: string | null;
  BrokerId?: number | null;
  classOfBusinessId?: number | null;
  InsurerId?: number | null;
  partnerId?: number | null;
  statuses?: ProductStatus[] | null;
}

export interface IProductDiscount {
  discount: IDiscount;
  discountId: number;
  premium: IPremiumRequest;
}

export interface ProductCategories {
  id: number;
  name: string;
  description?: string;
  imageUrl: string;
}

export type IProductDetails = (
  | IGeneralProduct
  | IMotorProduct
  | ITravelProduct
  | ILifeProduct
) & {
  id: number;
};

export type IEditProduct = (IGeneralProduct | ITravelProduct | ILifeProduct) & {
  id: number;
};
